import React from 'react';
import { FormBuilder } from 'commons-ui';
import { useStyletron } from 'styletron-react';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from './formConfig';
import useAthenaViewDetails from './useAthenaViewDetails';

const AthenaViewDetails: React.FC<{}> = () => {
	const { showLoader, handleFormCancel, data } = useAthenaViewDetails();
	const [css] = useStyletron();

	return (
		<div>
			<h3
				className={css({
					textAlign: 'center',
					marginTop: '20px',
					marginBottom: '20px'
				})}>
				Athena CRUD Request Details
			</h3>
			<FormBuilder
				data={data}
				mode='view'
				showLoader={showLoader}
				handleFormSubmit={() => {}}
				handleFormCancel={handleFormCancel}
				setShowLoader={() => {}}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				buttonLabels={{
					submitLabel: 'View',
					discardLabel: 'Back'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default AthenaViewDetails;
